import { render, staticRenderFns } from "./NutritionContent.vue?vue&type=template&id=7e5c6288"
import script from "./NutritionContent.vue?vue&type=script&lang=js"
export * from "./NutritionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports